// ============================================
// gsap scrollTrigger
// ============================================
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

window.addEventListener('load', () => {
  ScrollTrigger.refresh();
});

window.addEventListener('resize', () => {
  ScrollTrigger.refresh();
});

// ============================================
// ページ内リンク
// ============================================
function pageScroll() {
  const links = document.querySelectorAll('a[href^="#"]:not(.-no-smooth):not(.l-header__skip-content)');

  if (!links.length) return;

  const getHeaderOffset = () => {
    const value = getComputedStyle(document.documentElement).getPropertyValue('--size-header-h');

    return -(parseFloat(value) || 0);
  };

  const scrollToAnchor = (href) => {
    if (href === '#') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      return;
    }

    const targetId = decodeURIComponent(href.slice(1));
    const target = document.getElementById(targetId);

    if (!target) return;

    const top = window.scrollY + target.getBoundingClientRect().top + getHeaderOffset();

    window.scrollTo({
      top,
      behavior: 'smooth',
    });
  };

  links.forEach((el) => {
    el.addEventListener('click', (e) => {
      const href = el.getAttribute('href');

      if (!href) return;

      e.preventDefault();

      scrollToAnchor(href);
    });
  });
}

// ============================================
// スクロールアニメーション
// ============================================
function inViewAnm() {
  ScrollTrigger.batch('.js-inview', {
    start: 'top 75%',
    end: 'bottom 75%',
    once: true,
    //markers: true,

    onEnter: (batch) => {
      batch.forEach((el) => el.classList.add('is-active'));
    },
  });
}

// ============================================
//  TOP MV下テキスト
// ============================================
function mvText() {
  gsap.registerPlugin(ScrollTrigger);

  gsap.utils.toArray('.js-text-anim span').forEach((line, i) => {
    gsap.to(line, {
      '--black-percent': '100%',
      scrollTrigger: {
        trigger: line,
        start: 'top 30%',
        end: 'bottom 20%',
        scrub: true,
      },
    });
  });
}

// ============================================
//  サイドタイトルの棒
// ============================================
function aboutLineScroll() {
  const sections = document.querySelectorAll('.c-container01');
  if (!sections.length) return;

  const lineHeight = 30;
  const pointSize = 3;
  const moveRange = lineHeight - pointSize;

  sections.forEach((section) => {
    const contents = section.querySelector('.c-container01__contents');
    const side = section.querySelector('.c-container01__side');
    const point = section.querySelector('.-point');

    if (!contents || !side || !point) return;

    ScrollTrigger.create({
      trigger: section,
      start: 'top 0',
      end: 'bottom 60%',
      pin: side,
      pinSpacing: false,
      scrub: true,
    });

    gsap.to(point, {
      y: moveRange,
      ease: 'none',
      scrollTrigger: {
        trigger: contents,
        start: 'top 30%',
        end: 'bottom 30%',
        scrub: true,
      },
    });
  });
}
// ============================================
//  c-head-img01のアニメーション
// ============================================
function headImg() {
  ScrollTrigger.batch('.c-head-img01', {
    start: 'top 60%',
    end: 'bottom 60%',
    once: true,

    onEnter: (batch) => {
      batch.forEach((el) => el.classList.add('is-active'));
    },
  });
}

// ============================================
//  TOP成長とキャリアの図
// ============================================
function careerImg() {
  ScrollTrigger.batch('.p-index-career__list', {
    start: 'top 60%',
    end: 'bottom 60%',
    once: true,

    onEnter: (batch) => {
      batch.forEach((el) => el.classList.add('is-active'));
    },
  });
  ScrollTrigger.batch('.career-line', {
    start: 'top 60%',
    end: 'bottom 60%',
    once: true,

    onEnter: (batch) => {
      batch.forEach((el) => el.classList.add('is-active'));
    },
  });
}

// ==========================
// 数字アニメーション
// ==========================
function countUpNumber() {
  gsap.utils.toArray('.js-number').forEach((target) => {
    const number = target.innerText;
    let count = 0;
    target.innerText = count;

    gsap.to(target, {
      scrollTrigger: {
        trigger: target,
        start: () => 'top 80%',
        onEnter: () => {
          const countUp = setInterval(() => {
            if (count < Number(number)) {
              if (Number(number) <= 50) {
                count++;
              } else if (Number(number) < 100) {
                count += 5;
              } else {
                count += 50;
              }
              target.innerText = count;

              if (number < count) {
                target.innerText = number;
              }
            } else {
              clearInterval(countUp);
            }
          }, 30);
        },
        once: true,
      },
    });
  });
}

export { pageScroll, inViewAnm, mvText, aboutLineScroll, headImg, careerImg, countUpNumber };
